import Icon from './Icon';
import type { IconAssetEnum, IconCombinedProps, IconProps, IconStyleEnum, IconValueProps } from './types';

export type { IconProps, IconAssetEnum, IconStyleEnum, IconValueProps, IconCombinedProps };
export default Icon;
